import React from "react";
import { FC } from "react";
import { CompanyPublicData } from "../../../../models";
import Typography from "../../../../components/Typography";
import { useTranslations } from "../../../../store/translations/hooks";
import { TK } from "../../../../store/translations/translationKeys";
import AppButton from '../../../../components/AppButton';

export const ServiceSelector: FC<{
    settings: CompanyPublicData | undefined
    value: string | undefined
    onUpdate: (value: string) => void
}> = ({
    settings,
    value,
    onUpdate,
}) => {
    const t = useTranslations()
    return (
        <div style={{display: 'flex', gap: 'var(--spacer-XS)', flexDirection: 'column'}}>
            {Object.entries(settings?.services ?? {}).map(([appointmentType, {name, description}], i) => (<>
                <div key={appointmentType} style={{display: 'flex', flexDirection: 'row', gap: 'var(--spacer-S)', background: i%2 === 0 ? 'whitesmoke' : undefined, borderRadius: '3px', padding: 'var(--spacer-XS)'}}>
                    <div style={{display: 'flex', flexDirection: 'column', flexGrow: 1, maxWidth: '600px'}}>
                        <Typography size="large">{name?.length ? name : appointmentType}</Typography>
                        <Typography size="small">{description}</Typography> 
                    </div>
                    <div style={{alignContent: 'center'}}>
                        <AppButton color="success" outline={value !== appointmentType} onClick={() => onUpdate(appointmentType)}>{t(TK.schedule)}</AppButton>
                    </div>
                </div>
            </>))}
        </div>
    )
}
